import api from './api';
import { Role, CreateRolePayload, RoleNameAvailabilityResponse } from '@/types';

/**
 * Role Service - API wrapper for RoleController endpoints
 * Backend: /api/role
 */
export const roleService = {
  /**
   * GET /api/role - List all roles
   * Note: Backend has AllowAnonymous but frontend should still be authenticated
   */
  getAll: () => api.get<Role[]>('/role'),

  /**
   * GET /api/role/{id} - Get single role by id
   * Backend returns RoleViewModel { id, name }
   */
  getById: (id: number) => api.get<Role>(`/role/${id}`),

  /**
   * POST /api/role - Create new role (Admin only)
   */
  create: (payload: CreateRolePayload) => api.post<Role>('/role', payload),

  /**
   * DELETE /api/role/{id} - Delete role (Admin only)
   * Backend returns 409 Conflict if role is assigned to users
   */
  delete: (id: number) => api.delete(`/role/${id}`),

  /**
   * GET /api/role/check-name?name={name} - Check role name availability
   * Returns { name, isAvailable } where isAvailable = !exists
   */
  checkNameAvailability: (name: string) =>
    api.get<RoleNameAvailabilityResponse>('/role/check-name', {
      params: { name },
    }),

  // Note: PUT /api/role/{id} for update is not currently implemented in backend
  // If backend adds this endpoint, uncomment below:
  // update: (id: number, payload: { name: string }) =>
  //   api.put<Role>(`/role/${id}`, payload),
};
